import React, { Component, createRef } from "react";
import commonUtil from "../../../utils/commonUtil";

export default class SingleSelectDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.wrapperRef = createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(event.target)
    ) {
      this.setState({ isOpen: false });
    }
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  handleSelect = (option) => {
    const { selectedOption, onChange, closeOnSelect = true } = this.props;

    if (option === selectedOption) {
      onChange(null);
    } else {
      onChange(option);
    }

    if (closeOnSelect) {
      this.setState({ isOpen: false });
    }
  };

  render() {
    const {
      options = [],
      selectedOption,
      placeholder = "Select an option",
      isGiftList = false,
    } = this.props;
    const { isOpen } = this.state;

    return (
      <div
        ref={this.wrapperRef}
        style={{ position: "relative"}}
        className="radio-dropdown-wrapper"
      >
        <div
          className={`${
            isOpen && "radio-dropdown-border"
          } radio-dropdown-container`}
          onClick={this.toggleDropdown}
        >
          <img
            src={commonUtil.getAssetURL() + "/images/swap_vert.svg"}
            alt="swap vert"
            className="swapvert_drop_icon"
          />
          <p className="selected_radio_drop_text"> {placeholder} </p>
          {isOpen ? (
            <img
              src={commonUtil.getAssetURL() + "/images/expand_less.svg"}
              alt="Expand More"
              className="expand_drop_icon"
            />
          ) : (
            <img
              src={commonUtil.getAssetURL() + "/images/expand_more.svg"}
              alt="Expand Less"
              className="expand_drop_icon"
            />
          )}
        </div>

        {isOpen && (
          <div
            className="radio-dropdown-options-container"
            style={{
              position: "absolute",
              top: "99%",
              left: "1%",
              backgroundColor: "#fff",
              borderRadius: "4px",
              boxShadow: "0px 0px 15px 0px rgba(24, 26, 54, 0.12)",
              zIndex: 1,
              ...(isGiftList && { left: "-57%" }),
            }}
          >
            {options.map((option, index) => (
              <label key={index} className="radio-dropdown-option-label">
                <input
                  type="checkbox"
                  checked={selectedOption === option.id}
                  onChange={() => this.handleSelect(option)}
                  style={{ marginRight: "8px" }}
                  className="checbox-input-radio-dropdown"
                />
                {option.value}
              </label>
            ))}
          </div>
        )}
      </div>
    );
  }
}
